// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__29vMu","fileBtn":"File_fileBtn__3j0eR","closeBtn":"File_closeBtn__1ib7d","fileSelected":"File_fileSelected__15y5K","disabled":"File_disabled__cxoI7"};